
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function withAuth(Component) {
  return function AuthenticatedComponent(props) {
    const navigate = useNavigate();

    useEffect(() => {
      const token = localStorage.getItem("hrdata");
      if (!token) {
        navigate('/'); 
      }
    }, []);

    return <Component {...props} />;
  };
}